import { render } from "./mutliColorsBrandInfo.vue?vue&type=template&id=c8a2135e&lang=true"
import script from "./mutliColorsBrandInfo.vue?vue&type=script&lang=js"
export * from "./mutliColorsBrandInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__